import { z } from "zod/v4";

import { StripeProductVersionList } from "../schemas/stripe";

import { OrganizationAgencyLinkDtoSchema } from "./organization-agency-links";
import { StripeSubscriptionStatusList } from "./organization-subscriptions";
import { StripeSubscriptionSummaryDtoSchema } from "./stripe-subscription-links";
import {
  StripeIntervalList,
  SubscriptionBillingProviderList,
} from "./subscriptions";

export const OrganizationSummarySubscriptionProductDtoSchema = z.object({
  stripePriceId: z.string(),
  price: z.number(),
  name: z.string(),
  interval: z.enum(StripeIntervalList),
  intervalCount: z.number().nullish(),
  agencyEmails: z.string().array().nullish(),
  status: z.enum(StripeSubscriptionStatusList),
  cancelAt: z.number().nullish(),
  stripeSubscriptionId: z.string().nullish(),
  stripeSubscriptionLinkId: z.uuid(),
  subscriptionSummary: StripeSubscriptionSummaryDtoSchema.optional(),
});

export type OrganizationSummarySubscriptionProductDto = z.infer<
  typeof OrganizationSummarySubscriptionProductDtoSchema
>;

export const OrganizationSummarySubscriptionDtoSchema = z.object({
  billingProvider: z.enum(SubscriptionBillingProviderList),
  status: z.enum(StripeSubscriptionStatusList),
  interval: z.enum(StripeIntervalList).nullish(),
  price: z.number().nullish(),
  name: z.string(),
  version: z.enum(StripeProductVersionList),
});

export type OrganizationSummarySubscriptionDto = z.infer<
  typeof OrganizationSummarySubscriptionDtoSchema
>;

export const OrganizationUsagesDtoSchema = z.object({
  ordersPerMonth: z.number(),
});

export type OrganizationUsages = z.infer<typeof OrganizationUsagesDtoSchema>;

export const OrganizationSummaryDtoSchema = z.object({
  id: z.uuid(),
  shopId: z.string(),
  name: z.string(),
  isInstalled: z.boolean(),
  createdAtTs: z.number(),
  usages: OrganizationUsagesDtoSchema,
  organizationSubscriptions: OrganizationSummarySubscriptionDtoSchema.array(),
  stripeSubscriptionSummaries: StripeSubscriptionSummaryDtoSchema.array(),
  agencies: OrganizationAgencyLinkDtoSchema.array(),
});

export type OrganizationSummaryDto = z.infer<
  typeof OrganizationSummaryDtoSchema
>;
